"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TaskRepeatType;
(function (TaskRepeatType) {
    TaskRepeatType["NEVER"] = "NEVER";
    TaskRepeatType["DAILY"] = "DAILY";
    TaskRepeatType["WEEKLY"] = "WEEKLY";
    TaskRepeatType["BIWEEKLY"] = "BIWEEKLY";
    TaskRepeatType["MONTHLY"] = "MONTHLY";
    TaskRepeatType["YEARLY"] = "YEARLY";
})(TaskRepeatType = exports.TaskRepeatType || (exports.TaskRepeatType = {}));
//# sourceMappingURL=TaskRepeatType.js.map